export const translations = {
  en: {
    // Navbar
    nav_home: 'Home',
    nav_services: 'Services',
    nav_about: 'About',
    nav_case_studies: 'Case Studies',
    nav_contact: 'Contact',
    nav_get_started: 'Get Started',

    // Hero
    hero_badge: 'Leading Digital Consultancy',
    hero_headline_1: 'Transform Your Business in the ',
    hero_headline_2: 'Digital Era',
    hero_subhead: 'Strategy. Technology. Results.',
    hero_desc:
      ' We partner with visionary leaders to build the future of their industries.',
    hero_cta_primary: 'Get Free Consultation',
    hero_cta_secondary: 'See Our Services',
    hero_stat_1_val: '500+',
    hero_stat_1_label: 'Global Clients',
    hero_stat_2_val: '10+',
    hero_stat_2_label: 'Years Experience',
    hero_stat_3_val: '98%',
    hero_stat_3_label: 'Success Rate',

    // Services
    services_title: 'Our Services',
    services_desc:
      'Comprehensive consulting solutions designed to accelerate growth, optimize operations, and drive digital innovation across your enterprise.',
    service_1_title: 'Digital Strategy & Transformation',
    service_1_desc:
      'Align your business goals with cutting-edge digital capabilities to stay ahead of market disruption.',
    service_2_title: 'Business Process Optimization',
    service_2_desc:
      'Streamline operations, reduce costs, and improve efficiency through intelligent automation and workflow redesign.',
    service_3_title: 'Technology Implementation',
    service_3_desc:
      'Seamlessly integrate enterprise software, CRM, and ERP systems tailored to your unique operational needs.',
    service_4_title: 'Data Analytics & BI',
    service_4_desc:
      'Transform raw data into actionable insights with advanced analytics, dashboards, and predictive modeling.',
    service_5_title: 'Digital Marketing & Growth',
    service_5_desc:
      'Drive customer acquisition and retention through data-driven omnichannel marketing strategies.',
    service_6_title: 'IT Consulting & Infrastructure',
    service_6_desc:
      'Modernize your IT architecture with scalable, secure cloud solutions and robust cybersecurity frameworks.',
    learn_more: 'Learn More',

    // Why Choose Us
    why_title: 'Why Industry Leaders Choose DAB',
    why_stat_1_val: '500+',
    why_stat_1_label: 'Projects Delivered',
    why_stat_2_val: '98%',
    why_stat_2_label: 'Client Satisfaction',
    why_stat_3_val: '15+',
    why_stat_3_label: 'Industries Served',
    why_stat_4_val: '10',
    why_stat_4_label: 'Years of Excellence',
    diff_1_title: 'Proven Methodology',
    diff_1_desc:
      'Our proprietary frameworks have been tested and refined across hundreds of successful enterprise transformations.',
    diff_2_title: 'Expert Team',
    diff_2_desc:
      'Work directly with seasoned industry veterans, not junior consultants learning on your dime.',
    diff_3_title: 'Measurable Results',
    diff_3_desc:
      'We tie our success to yours, focusing on quantifiable ROI and clear performance metrics.',
    diff_4_title: '24/7 Support',
    diff_4_desc:
      "Global presence ensures we're always available when critical business needs arise.",

    // Process
    process_title: 'How We Work',
    process_desc:
      'A structured, transparent approach to delivering transformative results.',
    step_1_title: 'Discovery & Analysis',
    step_1_desc:
      'Deep dive into your current operations, market position, and technological landscape.',
    step_2_title: 'Strategy Design',
    step_2_desc:
      'Develop a customized roadmap aligning business objectives with digital capabilities.',
    step_3_title: 'Implementation',
    step_3_desc:
      'Execute the strategy with agile methodologies, ensuring minimal disruption.',
    step_4_title: 'Measurement & Optimization',
    step_4_desc:
      'Track KPIs, analyze outcomes, and continuously refine for maximum ROI.',

    // Industries
    ind_title: 'Industries We Serve',
    ind_1: 'Healthcare',
    ind_2: 'Finance',
    ind_3: 'Retail',
    ind_4: 'Manufacturing',
    ind_5: 'Real Estate',
    ind_6: 'Technology',
    ind_7: 'Education',
    ind_8: 'Logistics',

    // Testimonials
    test_title: 'Trusted by Industry Leaders',
    test_1_quote:
      'DAB completely transformed our legacy systems. Their strategic approach not only modernized our infrastructure but increased our operational efficiency by 40%.',
    test_1_role: 'CTO',
    test_2_quote:
      'The level of expertise and dedication from the DAB team is unmatched. They delivered our digital transformation project ahead of schedule and exceeded all KPIs.',
    test_2_role: 'VP of Operations',
    test_3_quote:
      'Partnering with DAB was the best decision we made for our growth strategy. Their data-driven insights helped us capture 25% more market share in just one year.',
    test_3_role: 'CEO',

    // Case Studies
    case_title: 'Proven Results',
    case_desc:
      "Explore how we've helped organizations overcome complex challenges and achieve unprecedented growth.",
    case_view_all: 'View All Case Studies',
    case_challenge: 'Challenge:',
    case_read_full: 'Read Full Case Study',
    case_1_ind: 'Healthcare',
    case_1_chal:
      'Legacy patient data systems causing critical delays in care delivery and billing.',
    case_1_met_label: 'Reduction in Processing Time',
    case_1_title: 'Modernizing Health Records',
    case_2_ind: 'Finance',
    case_2_chal:
      'High customer churn due to outdated mobile banking experience and slow support.',
    case_2_met_label: 'Increase in Mobile Engagement',
    case_2_title: 'Next-Gen Banking App',
    case_3_ind: 'Manufacturing',
    case_3_chal:
      'Supply chain blind spots leading to inventory shortages and production halts.',
    case_3_met_label: 'Annual Cost Savings',
    case_3_title: 'Predictive Supply Chain',

    // Contact
    contact_banner_title: 'Ready to Transform Your Business?',
    contact_banner_desc:
      'Schedule a free 30-minute strategy session today and discover how DAB can accelerate your digital journey.',
    contact_info_title: 'Get in Touch',
    contact_info_desc:
      "Reach out to our team of experts. We're here to answer your questions and discuss your business needs.",
    contact_phone: 'Phone',
    contact_email: 'Email',
    contact_hq: 'Headquarters',
    contact_hours: 'Office Hours',
    contact_hours_val: 'Mon - Fri: 8:00 AM - 6:00 PM PST',
    form_name: 'Full Name *',
    form_name_ph: 'John Doe',
    form_email: 'Work Email *',
    form_email_ph: 'john@company.com',
    form_company: 'Company Name',
    form_company_ph: 'Acme Corp',
    form_service: 'Service Interest',
    form_service_ph: 'Select a service...',
    form_msg: 'How can we help you? *',
    form_msg_ph: 'Tell us about your project or challenges...',
    form_submit: 'Book Free Consultation',

    // Footer
    footer_desc:
      'Driving Digital Excellence. We partner with visionary leaders to build the future of their industries through strategy, technology, and measurable results.',
    footer_col_1: 'Services',
    footer_col_2: 'Company',
    footer_col_3: 'Resources',
    footer_link_about: 'About Us',
    footer_link_team: 'Our Team',
    footer_link_careers: 'Careers',
    footer_link_blog: 'Blog & Insights',
    footer_link_whitepapers: 'Whitepapers',
    footer_link_webinars: 'Webinars',
    footer_link_faq: 'FAQ',
    footer_copy:
      '© 2024 DAB Digital Business Consulting. All rights reserved.',
    footer_privacy: 'Privacy Policy',
    footer_terms: 'Terms of Service',
    footer_cookies: 'Cookie Policy',
  },
  es: {
    // Navbar
    nav_home: 'Inicio',
    nav_services: 'Servicios',
    nav_about: 'Nosotros',
    nav_case_studies: 'Casos de Éxito',
    nav_contact: 'Contacto',
    nav_get_started: 'Comenzar',

    // Hero
    hero_badge: 'Consultoría Digital Líder',
    hero_headline_1: 'Transforma tu Negocio en la ',
    hero_headline_2: 'Era Digital',
    hero_subhead: 'Estrategia. Tecnología. Resultados.',
    hero_desc:
      ' Nos asociamos con líderes visionarios para construir el futuro de sus industrias.',
    hero_cta_primary: 'Consulta Gratuita',
    hero_cta_secondary: 'Ver Servicios',
    hero_stat_1_val: '500+',
    hero_stat_1_label: 'Clientes Globales',
    hero_stat_2_val: '10+',
    hero_stat_2_label: 'Años de Experiencia',
    hero_stat_3_val: '98%',
    hero_stat_3_label: 'Tasa de Éxito',

    // Services
    services_title: 'Nuestros Servicios',
    services_desc:
      'Soluciones integrales de consultoría diseñadas para acelerar el crecimiento, optimizar operaciones e impulsar la innovación digital en su empresa.',
    service_1_title: 'Estrategia y Transformación Digital',
    service_1_desc:
      'Alinee sus objetivos comerciales con capacidades digitales de vanguardia para mantenerse a la vanguardia de la disrupción del mercado.',
    service_2_title: 'Optimización de Procesos',
    service_2_desc:
      'Agilice las operaciones, reduzca costos y mejore la eficiencia mediante la automatización inteligente y el rediseño del flujo de trabajo.',
    service_3_title: 'Implementación Tecnológica',
    service_3_desc:
      'Integre sin problemas software empresarial, CRM y sistemas ERP adaptados a sus necesidades operativas únicas.',
    service_4_title: 'Análisis de Datos y BI',
    service_4_desc:
      'Transforme datos sin procesar en información procesable con análisis avanzados, paneles y modelos predictivos.',
    service_5_title: 'Marketing Digital y Crecimiento',
    service_5_desc:
      'Impulse la adquisición y retención de clientes a través de estrategias de marketing omnicanal basadas en datos.',
    service_6_title: 'Consultoría de TI e Infraestructura',
    service_6_desc:
      'Modernice su arquitectura de TI con soluciones en la nube escalables y seguras y marcos de ciberseguridad sólidos.',
    learn_more: 'Saber Más',

    // Why Choose Us
    why_title: 'Por Qué los Líderes Eligen DAB',
    why_stat_1_val: '500+',
    why_stat_1_label: 'Proyectos Entregados',
    why_stat_2_val: '98%',
    why_stat_2_label: 'Satisfacción del Cliente',
    why_stat_3_val: '15+',
    why_stat_3_label: 'Industrias Atendidas',
    why_stat_4_val: '10',
    why_stat_4_label: 'Años de Excelencia',
    diff_1_title: 'Metodología Probada',
    diff_1_desc:
      'Nuestros marcos patentados han sido probados y perfeccionados en cientos de transformaciones empresariales exitosas.',
    diff_2_title: 'Equipo Experto',
    diff_2_desc:
      'Trabaje directamente con veteranos experimentados de la industria, no con consultores junior que aprenden a su costa.',
    diff_3_title: 'Resultados Medibles',
    diff_3_desc:
      'Vinculamos nuestro éxito al suyo, centrándonos en un ROI cuantificable y métricas de rendimiento claras.',
    diff_4_title: 'Soporte 24/7',
    diff_4_desc:
      'Nuestra presencia global garantiza que siempre estemos disponibles cuando surjan necesidades comerciales críticas.',

    // Process
    process_title: 'Cómo Trabajamos',
    process_desc:
      'Un enfoque estructurado y transparente para ofrecer resultados transformadores.',
    step_1_title: 'Descubrimiento y Análisis',
    step_1_desc:
      'Inmersión profunda en sus operaciones actuales, posición en el mercado y panorama tecnológico.',
    step_2_title: 'Diseño de Estrategia',
    step_2_desc:
      'Desarrolle una hoja de ruta personalizada que alinee los objetivos comerciales con las capacidades digitales.',
    step_3_title: 'Implementación',
    step_3_desc:
      'Ejecute la estrategia con metodologías ágiles, asegurando una interrupción mínima.',
    step_4_title: 'Medición y Optimización',
    step_4_desc:
      'Realice un seguimiento de los KPI, analice los resultados y perfeccione continuamente para obtener el máximo ROI.',

    // Industries
    ind_title: 'Industrias que Atendemos',
    ind_1: 'Salud',
    ind_2: 'Finanzas',
    ind_3: 'Comercio',
    ind_4: 'Manufactura',
    ind_5: 'Bienes Raíces',
    ind_6: 'Tecnología',
    ind_7: 'Educación',
    ind_8: 'Logística',

    // Testimonials
    test_title: 'Confiado por Líderes de la Industria',
    test_1_quote:
      'DAB transformó por completo nuestros sistemas heredados. Su enfoque estratégico no solo modernizó nuestra infraestructura, sino que aumentó nuestra eficiencia operativa en un 40%.',
    test_1_role: 'Director de Tecnología',
    test_2_quote:
      'El nivel de experiencia y dedicación del equipo de DAB es inigualable. Entregaron nuestro proyecto de transformación digital antes de lo previsto y superaron todos los KPI.',
    test_2_role: 'VP de Operaciones',
    test_3_quote:
      'Asociarnos con DAB fue la mejor decisión que tomamos para nuestra estrategia de crecimiento. Sus conocimientos basados en datos nos ayudaron a capturar un 25% más de participación de mercado en solo un año.',
    test_3_role: 'Directora General',

    // Case Studies
    case_title: 'Resultados Comprobados',
    case_desc:
      'Explore cómo hemos ayudado a las organizaciones a superar desafíos complejos y lograr un crecimiento sin precedentes.',
    case_view_all: 'Ver Todos los Casos',
    case_challenge: 'Desafío:',
    case_read_full: 'Leer Caso Completo',
    case_1_ind: 'Salud',
    case_1_chal:
      'Sistemas de datos de pacientes heredados que causan retrasos críticos en la prestación de atención y la facturación.',
    case_1_met_label: 'Reducción en Tiempo de Procesamiento',
    case_1_title: 'Modernización de Registros Médicos',
    case_2_ind: 'Finanzas',
    case_2_chal:
      'Alta rotación de clientes debido a una experiencia de banca móvil obsoleta y soporte lento.',
    case_2_met_label: 'Aumento en Participación Móvil',
    case_2_title: 'App Bancaria de Próxima Generación',
    case_3_ind: 'Manufactura',
    case_3_chal:
      'Puntos ciegos en la cadena de suministro que provocan escasez de inventario y paradas de producción.',
    case_3_met_label: 'Ahorro Anual de Costos',
    case_3_title: 'Cadena de Suministro Predictiva',

    // Contact
    contact_banner_title: '¿Listo para Transformar tu Negocio?',
    contact_banner_desc:
      'Programe una sesión de estrategia gratuita de 30 minutos hoy y descubra cómo DAB puede acelerar su viaje digital.',
    contact_info_title: 'Ponte en Contacto',
    contact_info_desc:
      'Comuníquese con nuestro equipo de expertos. Estamos aquí para responder sus preguntas y discutir sus necesidades comerciales.',
    contact_phone: 'Teléfono',
    contact_email: 'Correo Electrónico',
    contact_hq: 'Sede Central',
    contact_hours: 'Horario de Oficina',
    contact_hours_val: 'Lun - Vie: 8:00 AM - 6:00 PM PST',
    form_name: 'Nombre Completo *',
    form_name_ph: 'Juan Pérez',
    form_email: 'Correo de Trabajo *',
    form_email_ph: 'juan@empresa.com',
    form_company: 'Nombre de la Empresa',
    form_company_ph: 'Empresa S.A.',
    form_service: 'Servicio de Interés',
    form_service_ph: 'Seleccione un servicio...',
    form_msg: '¿Cómo podemos ayudarte? *',
    form_msg_ph: 'Cuéntanos sobre tu proyecto o desafíos...',
    form_submit: 'Reservar Consulta Gratuita',

    // Footer
    footer_desc:
      'Impulsando la Excelencia Digital. Nos asociamos con líderes visionarios para construir el futuro de sus industrias a través de la estrategia, la tecnología y resultados medibles.',
    footer_col_1: 'Servicios',
    footer_col_2: 'Empresa',
    footer_col_3: 'Recursos',
    footer_link_about: 'Sobre Nosotros',
    footer_link_team: 'Nuestro Equipo',
    footer_link_careers: 'Carreras',
    footer_link_blog: 'Blog e Insights',
    footer_link_whitepapers: 'Documentos Técnicos',
    footer_link_webinars: 'Seminarios Web',
    footer_link_faq: 'Preguntas Frecuentes',
    footer_copy:
      '© 2024 DAB Digital Business Consulting. Todos los derechos reservados.',
    footer_privacy: 'Política de Privacidad',
    footer_terms: 'Términos de Servicio',
    footer_cookies: 'Política de Cookies',
  },
}

export type Language = 'en' | 'es'
export type TranslationKey = keyof typeof translations.en
